import { NetworkConfiguration } from "../network/networkConfriguation";
import { callAPI } from "../network/networkConnection";

export const NotificationApiService = {
  getNotifications(query = "?page=1&limit=10") {
    return callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.NOTIFICATIONS + query,
      "GET",
      { "Content-Type": "application/json" }
    );
  },
  getUnseenCount() {
    return callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.NOTIFICATIONS_UNSEEN_COUNT,
      "GET",
      { "Content-Type": "application/json" }
    );
  },
  markAllSeen() {
    return callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.NOTIFICATIONS_MARK_ALL_SEEN,
      "PUT",
      { "Content-Type": "application/json" }
    );
  }
};


